import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  update_note: {
    id: 'update_note',
    defaultMessage: 'Note di aggiornamento',
  },
});

const BandoUpdateNote = ({ content }) => {
  const intl = useIntl();
  return content?.update_note?.length > 0 ? (
    <section
      id="update_note"
      menu_title={intl.formatMessage(messages.update_note)}
    >
      <h2
        id="header-update_note"
        className="mb-3 h4 visually-hidden"
        aria-hidden={true}
      >
        {intl.formatMessage(messages.update_note)}
      </h2>
      <p>
        <strong className="font-serif">
          {intl.formatMessage(messages.update_note)}:
        </strong>{' '}
        {content.update_note}
      </p>
    </section>
  ) : null;
};

BandoUpdateNote.propTypes = {
  content: PropTypes.shape({
    riferimenti_bando: PropTypes.shape({
      data: PropTypes.string,
    }),
  }).isRequired,
};
export default BandoUpdateNote;
